<template>
    <!-- Maybe the dropdown logic could be moved to a generic component -->
    <div id="langSwitch" class="dropdown bottom-left" :class="{'open': isOpen}">
        <div class="current-language" @click="isOpen = !isOpen">
            <span>{{ $t(`languages.${i18n.locale.value}.code`) }}</span>
            <span class="dropdown-arrow"></span>
        </div>

        <ul class="languages-list dropdown-menu">
            <li
                v-for="locale in i18n.availableLocales"
                :key="locale"
                @click="changeLocale(locale)"
                :class="{'active': i18n.locale.value === locale}"
            >
                {{ $t(`languages.${locale}.name`) }}
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
    setup()
    {
        const i18n = useI18n();
        const isOpen = ref(false);

        function changeLocale(newLocale: string): void
        {
            i18n.locale.value = newLocale;
            isOpen.value = false;
        }

        return {
            i18n,
            isOpen,
            changeLocale,
        };
    },
})
</script>

<style lang="scss" scoped>

#langSwitch {
    display: flex;
    padding: 0;
}

.current-language {
    display: flex;
    align-items: center;
    padding: 0.4rem 0.75rem;
    cursor: pointer;
}

</style>
